import { render, staticRenderFns } from "./credit-allocation-mana.vue?vue&type=template&id=4b73dd6a"
import script from "./credit-allocation-mana.vue?vue&type=script&lang=js"
export * from "./credit-allocation-mana.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports